import { BaseUuidEntity } from "./base/sys$BaseUuidEntity";
import { AbstractBprocRequest } from "./base/AbstractBprocRequest";
import { PersonGroupExt } from "./base/base$PersonGroupExt";
import { FileDescriptor } from "./base/sys$FileDescriptor";
import { AbstractDictionary } from "./base/AbstractDictionary";
import { DicRequestStatus } from "./base/tsadv$DicRequestStatus";

export class OrderRegister extends BaseUuidEntity {
  static NAME = "kzm_OrderRegister";
  orderNumber?: string | null;
  requestNumber?: string | null;
  toDate?: string | null;
  orderDate?: string | null;
  comment?: string | null;
  fromDate?: string | null;
}

export class OrderRegisterFile {
  originalFile: FileDescriptor;
  pdfFile: FileDescriptor;
}

export class OrderRegisterFull extends BaseUuidEntity {
  static NAME = "kzm_OrderRegister";
  _entityName: string;
  _instanceName: string;
  orderNumber: string;
  orderDate: string;
  comment: string;
  approver: PersonGroupExt;
  parentOrder: OrderRegister;
  employees: { employee: PersonGroupExt }[];
  files: Partial<OrderRegisterFile>[];
  mainData: Record<string, any>;
  orderType: AbstractDictionary;
  recipients: any[];
  responsible: PersonGroupExt;
  status: DicRequestStatus;
  registerOrderRequest: any;
}

export class RegisterOrderRequest extends AbstractBprocRequest {
  static NAME = "kzm_RegisterOrderRequest";
  order: OrderRegisterFull;
}
